import { createAction } from 'redux-actions';

import { getSubscriptionInfo, getSubscriptionStatus } from '../api/packageInfo';
import { REQUEST_SUBSCRIPTION_INFO_SUCCESS, REQUEST_SUBSCRIPTION_INFO_FAILURE, STRIPE_STATUS_FAILURE,STRIPE_STATUS_SUCCESS } from '../constants/actionTypes';
import { showErrorSnackbar } from './snackbar';


const requestSubscriptionInfoSuccess = createAction('REQUEST_SUBSCRIPTION_INFO_SUCCESS');
const requestSubscriptionInfoFailure = createAction('REQUEST_SUBSCRIPTION_INFO_FAILURE');
const stripeStatusSuccess = createAction('STRIPE_STATUS_SUCCESS');
const stripeStatusFailure = createAction('STRIPE_STATUS_FAILURE');

// eslint-disable-next-line import/prefer-default-export
export function requestSubscriptionInfo() {
 return dispatch => getSubscriptionInfo()
    .then(({ data }) => dispatch(requestSubscriptionInfoSuccess(data)))
    .catch(error => {
      if(error?.response?.status === 401){
        dispatch(showErrorSnackbar('Session is Expired!!!'));
      }else{
      dispatch(requestSubscriptionInfoFailure(error))}});
}

export function requestSubscriptionStatus() {
  return dispatch => getSubscriptionStatus()
     .then(({ data }) => dispatch(stripeStatusSuccess(data)))
     .catch(error => {
       if(error?.response?.status === 401){
         dispatch(showErrorSnackbar('Session is Expired!!!'));
       }else{
       dispatch(stripeStatusFailure(error))}});
 }
